import React from "react";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Tooltip } from "components/general/Tooltip";
import { FlexBetweenContainer } from "../../containers/FlexBetweenContainer";
import { FlexContainer } from "../../containers/FlexContainer";
import { DetailsRightColumnText } from "./elements/DetailsRightColumnText";
import { DetailsLeftColumnText } from "./elements/DetailsLeftColumnText";

export const SlippageRow: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const slippageText =
    "Difference between the price you see and the price that you get. You will not encounter slippage on Bebop.";

  return (
    <FlexBetweenContainer data-testid="slippage-row" widthExpand={true}>
      <FlexContainer>
        <FlexContainer style={{ color: theme.font.secondary.default }}>
          <FlexContainer>
            <Tooltip placement="right" title={slippageText}>
              <DetailsLeftColumnText>Slippage</DetailsLeftColumnText>
            </Tooltip>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      <DetailsRightColumnText>0%</DetailsRightColumnText>
    </FlexBetweenContainer>
  );
};
